import { render } from "./fastReplayItem.vue?vue&type=template&id=bd658468&scoped=true"
import script from "./fastReplayItem.vue?vue&type=script&lang=js"
export * from "./fastReplayItem.vue?vue&type=script&lang=js"

import "./fastReplayItem.vue?vue&type=style&index=0&id=bd658468&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd658468"]])

export default __exports__